import { AuthService } from './../../services/auth.service';
import { Location } from '@angular/common';
import { ClientesPymesService } from './../../services/clientes-pymes.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-fiscal',
  templateUrl: './fiscal.component.html',
  styleUrls: ['./fiscal.component.css']
})
export class FiscalComponent implements OnInit {

  codcliente:number;
  anio:number;
  periodo:string;
  idcategoria:number;
  categorias;
  documentosImpuestosPresentados;
  documentosImpuestosAPresentar;
  documentosActuaciones;
  documentosOtros;
  documentosFacturas;

  constructor(private activatedRoute:ActivatedRoute, private clientesPymesService:ClientesPymesService,
    private location:Location, private router:Router, private auth:AuthService) { 

    this.activatedRoute.queryParams
    .subscribe(params=>{
      this.codcliente=params["idC"];
      this.anio=params["a"];
      this.idcategoria=params["c"];

      if(this.auth.esClientePymes() && this.codcliente && this.codcliente!=this.auth.usuarioActivo.CLcodigo){
        this.router.navigate(['/home']);
        return false;
      }

      if(this.codcliente && this.anio && !this.idcategoria){
        this.cargarCategorias(this.codcliente, this.anio);
      }

      if(this.idcategoria && !this.codcliente){
        this.cargarMes(this.idcategoria);
        this.cargarCategoriaActual(this.idcategoria);
        this.cargarDocumentos(this.idcategoria, 'IP');
        this.cargarDocumentos(this.idcategoria, 'IC');
        this.cargarDocumentos(this.idcategoria, 'AC');
        this.cargarDocumentos(this.idcategoria, 'OT');
        this.cargarDocumentos(this.idcategoria, 'FA');
      }
      
    });
  }


  ngOnInit() {
  }

  cargarCategorias(codcliente, anio){
    this.clientesPymesService.cargarCategoriasFiscal(codcliente, anio)
    .subscribe(resp=>{
      this.categorias=resp;
    });
  }
  
  cargarDocumentos(codpadre, codtipodoc){
    
    this.clientesPymesService.cargarDocumentos(codpadre, codtipodoc)
    .subscribe(resp=>{
      switch(codtipodoc){
        case 'IP':
          this.documentosImpuestosPresentados=resp;
        break;
        case 'IC':
          this.documentosImpuestosAPresentar=resp;
        break;
        case 'AC':
          this.documentosActuaciones=resp;
        break;
        case 'OT':
          this.documentosOtros=resp;
        break;
        case 'FA':
          this.documentosFacturas=resp;
        break;
      }
      
    });
  }

  cargarMes(codCategoria){
    this.clientesPymesService.cargarMes(codCategoria)
    .subscribe(resp=>{
      this.periodo=resp["DLcategoria"];
      this.anio=resp["DLanio"];
    });
  }

  cargarCategoriaActual(codCategoria){
    this.clientesPymesService.cargarCategoriaActual(codCategoria)
    .subscribe(resp=>{
      if(resp["err"]==true){
        this.router.navigate(["/home"]);
        return false;
      }
    });
  }

  volver(){
    this.location.back();
  }

  descargarDoc(ruta:string){
    
    let rutaspliteada=ruta.split("/");
    let nombrearchivo=rutaspliteada[rutaspliteada.length-1];
    
    //window.location.href='https://app.solucionlegal.es/API/index.php/auth/descargar';
    this.clientesPymesService.descargarDoc(ruta)
    .subscribe(data=>saveAs(data, nombrearchivo)),
    error=> console.log("Error downloading"),
    ()=>console.log("Nice.");
    //data=>window.open(window.URL.createObjectURL(data))
  }

  borrarDoc(codigoDoc, codtipodoc){
    if(confirm("¿Desea borrar el documento seleccionado?")){
      this.clientesPymesService.borrarDoc(codigoDoc)
      .subscribe(resp=>{
        this.cargarDocumentos(this.idcategoria, codtipodoc);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/fiscal/fiscal.component.ts